var React = require('react');

function AvailableForIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"available-for-icon"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M81.59,26V.42H71V17.86L47.87,0,0,36.78v9.34H7.63V91.89H88.26V45.59h7.48V37ZM79.08,80.66H16.55V36.78L47.87,13.44,79.08,36.78Z","style":{"fill":"#97c14c"},"key":0}),React.createElement("polygon",{"points":"26.36 70.63 69.39 70.63 69.39 41.07 47.91 25.34 26.36 41.07 26.36 70.63","style":{"fill":"#97c14c"},"key":1})])]);
}

AvailableForIcon.defaultProps = {"width":"95.74","height":"91.89","viewBox":"0 0 95.74 91.89"};

module.exports = AvailableForIcon;

AvailableForIcon.default = AvailableForIcon;
